
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
  computed: {
  },
})
export default class SidebarLayers extends Vue {
  public toggleIcon: string;
  public selectedWMSLayers: string[];
  public panel: number[];

  @Prop() readonly wsmlayers: object[];

  constructor() {
    super();

    this.selectedWMSLayers = [];
    this.toggleIcon = "mdi-layers-outline";
    this.panel = [0];
  }

  toggleWMSLayers() {
    this.$emit("toggle-wms-layer", this.selectedWMSLayers);
  }

  get getWmsLayers() {
    this.selectedWMSLayers = this.wsmlayers.filter(x => x["selected"]).map(x => x["id"]);
    return this.wsmlayers;
  }

  public toggleSidebar() {
    const elem = document.getElementById("sidebar-layer");

    if (elem) {
      const classes = elem.className.split(" ");
      const collapsed = classes.indexOf("collapsed") !== -1;
      if (collapsed) {
        classes.splice(classes.indexOf("collapsed"), 1);

        setTimeout(() => {
          this.toggleIcon = "mdi-arrow-collapse-right";
        }, 100);
      } else {
        classes.push("collapsed");

        setTimeout(() => {
          this.toggleIcon = "mdi-layers-outline";
        }, 550);
      }
      elem.className = classes.join(" ");
    }
  }
}
